<div class="col-md-12 text-center">
    <h2>OR</h2>
</div>

<div class="col-md-12 text-center">
    <button type="button" class="login-btn login-btn--google" #loginRef>
        Login with Google
    </button>

    <button type="button" class="login-btn login-btn--facebook" (click)="login()">
        Login with Facebook
    </button>
</div>